import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/WechatIMG6281.jpg'


const _hoisted_1 = { class: "tab-bar-menu" }

import {CloseOutlined, GiftFilled, HomeFilled, IdcardOutlined, LogoutOutlined} from '@ant-design/icons-vue'
import {IconFont} from "@/lib/util";
import HeaderLogoView from "@/views/share/HeaderLogoView.vue";
import {session} from "@/model/session";
import {h, reactive} from "vue"
import PopupBase from "@/views/share/PopupBase.vue";
import {message} from "ant-design-vue";
import router from "@/views";
import dayjs from "dayjs";
import {useRoute} from "vue-router";
import {UserAgent} from "@/model/user_agent";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderView',
  setup(__props) {


const info = reactive({show: {contact: false, bill: false}});
const agent = useRoute().meta.agent as UserAgent;

const showBill = () => {
  info.show.bill = true;
}


const logout = () => {
  const done = message.loading('加载中', 0)
  session.logout().then(() => router.push('/login')).finally(done)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderLogoView),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: _normalizeClass({active:_ctx.$route.path == '/'})
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(HomeFilled)),
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "首页", -1))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/activities",
        class: _normalizeClass({active:_ctx.$route.path.includes('activities')})
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IconFont), { type: "icon-dashboard" }),
          _cache[5] || (_cache[5] = _createElementVNode("span", null, "活动", -1))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/brand",
        class: _normalizeClass({active:_ctx.$route.path.includes('brand')})
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IconFont), { type: "icon-dashboard" }),
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "管理", -1))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/service",
        class: _normalizeClass({active:_ctx.$route.path.includes('service')})
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(GiftFilled)),
          _cache[7] || (_cache[7] = _createElementVNode("span", null, "服务", -1))
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createVNode(_component_a_menu, {
      mode: "horizontal",
      "selected-keys": [],
      class: "menu-right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_menu_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/service/ad" }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("广告")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_menu_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/service/wallet" }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("获客费用")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_menu_item, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (info.show.contact=true))
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("客服")
          ])),
          _: 1
        }),
        _createVNode(_component_a_menu_item, { onClick: showBill }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("账单")
          ])),
          _: 1
        }),
        _createVNode(_component_a_sub_menu, null, {
          title: _withCtx(() => [
            _createVNode(_component_a_flex, {
              style: {"height":"70px"},
              align: "center",
              gap: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  vertical: "",
                  align: "flex-end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_typography_text, { type: "secondary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(agent).meta.account.phone_number), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_typography_text, { type: "secondary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(agent).meta.account.level), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_avatar, {
                  size: 46,
                  src: `https://static.pms.guandb.cn/media/system/wechat/head/${_unref(agent).meta.account.wx_union_id}.jpg-sq.60`
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_flex, {
              vertical: "",
              gap: 18,
              class: "menu-right-account-sub-title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  justify: "space-between",
                  gap: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_typography_text, {
                      copyable: "",
                      strong: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(agent).meta.account.phone_number), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_flex, { align: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tag, {
                      color: {'体验版':'default','基础版':'#D99058','专业版':'#eeb400'}[_unref(agent).meta.account.level.toString()]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(agent).meta.account.level), 1)
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    (_unref(agent).meta.account.level == '体验版')
                      ? (_openBlock(), _createBlock(_component_a_typography_text, { key: 0 }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createTextVNode("永久")
                          ])),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_typography_text, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("剩余： " + _toDisplayString(_unref(dayjs)(_unref(agent).meta.account.expiration).diff(_unref(dayjs)(), 'days')) + "天 ", 1)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_divider, { type: "divider" }),
            _createVNode(_component_a_menu_item, {
              icon: h(_unref(IconFont),{type:'icon-wepay'})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/account/merchant" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("收款商户")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_a_menu_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/account/wallet" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_flex, {
                      justify: "space-between",
                      align: "center",
                      style: {"height":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IconFont), { type: "icon-wallet-outline" }),
                        _createVNode(_component_a_typography_text, { style: {"flex":"1"} }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode("拓客资金包")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_typography_text, {
                          strong: "",
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("¥" + _toDisplayString(_unref(agent).meta.account.wallet_balance), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, {
              icon: h(_unref(IdcardOutlined))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/account" }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("账户资料")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_a_menu_divider, { type: "divider" }),
            _createVNode(_component_a_menu_item, {
              key: "logout",
              icon: h(_unref(LogoutOutlined)),
              onClick: logout
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode("退出")
              ])),
              _: 1
            }, 8, ["icon"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(PopupBase, {
      open: info.show.contact,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((info.show.contact) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(CloseOutlined), {
          style: {"position":"absolute","top":"14px","right":"14px","color":"white"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (info.show.contact=false))
        }),
        _cache[17] || (_cache[17] = _createElementVNode("img", {
          src: _imports_0,
          style: {"max-width":"400px"},
          alt: ""
        }, null, -1))
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_drawer, {
      title: "账单记录",
      placement: "right",
      closable: true,
      open: info.show.bill,
      "get-container": ".app-main",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (info.show.bill = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table)
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})